/**
 * TTS Service Interface (Abstract Class)
 */
export class TtsService {
  /**
   * Speak the given text
   * @param {string} text 
   * @param {object} options - { locale, voice, ... }
   * @returns {Promise<void>}
   */
  async speak(text, options = {}) {
    throw new Error('Not implemented');
  }

  /**
   * Stop any ongoing speech
   */
  async stop() {
    // Optional
  }
}
